<form [formGroup]="deepFormGroup">
  <digires-state-indicator [formCtrlName]="fullFormCtrlName" [readOnly]="readOnly" [readOnlyReason]="readOnlyReason" [finModel]="finModel"></digires-state-indicator>
  <mat-form-field *ngIf="readOnly" [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label>
      <input matInput type="text"
             [value]="getReadonlyValue()"
             readonly>
    </label>

    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!readOnly" [ngClass]="{'changed':isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <mat-select [required]="required && !readOnly"
                formControlName="{{formCtrlName}}"
                disableOptionCentering
                panelClass="mat-dropdown-panel-override"
                (selectionChange)="onInputChanged()">
      <mat-option [value]="null"></mat-option>
      <mat-option *ngFor="let opt of allOptions" [disabled]="!opt.selectable" [value]="opt.id" matTooltip="{{opt.label}}">
        {{opt.label}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-icon *ngIf="!!tooltip" class="tooltip-icon" matTooltipPosition="above" matTooltip="{{tooltip}}" svgIcon="tooltip"></mat-icon>
  <mat-icon *ngIf="!!finModel" class="warning-triangle" [class.transparent]="!finModel.hasUpload || !finModel.isReadable(fullFormCtrlName) || finModel.isRead(fullFormCtrlName)"
            matTooltip="Note: The value in this field was not populated by the most recent upload of the financial model">
    warning
  </mat-icon>
</form>
